export enum ErrorCodes {
    InvalidRequest = 1000,
    NameAlreadyUsed = 1001,
    ItemNotFound = 1002,
    InvalidFolder = 1100,
    MachineAlreadyPairedWithDifferentLicenseKey = 1200,
    UserIsLockedOut = 1401,
    TaskAssignmentError = 2400,
}

export enum AccessCode {
    PermissionRequired,
    NotFound,
    FeatureNotEnabled,
    FolderRequired,
    FeatureNotLicensed,
    ClassicFolderRequired,
}

export enum ErrorStatus {
    InvalidAntiForgeryToken = 'Empty or invalid anti forgery header token.',
}

export enum ClientErrorCodes {
    GenericError = 100,
    NetworkError = 101,
    SessionExpired = 102,
    InvalidJSON = 150,
    InvalidFile = 151,
    InvalidLicenseFormat = 152,
    TriggersNotAllEnabled = 153,
    TransactionItemsFailed = 154,
    InvalidWebHookID = 155,
    BulkUpdateProcessesFailed = 156,
    UnknownUiError = 199,
}

export enum ClientAuthErrorCodes {
    UnknownError = 200,
    InvalidUser = 201,
    CannotConnectToADDomain = 202,
    UnknownExternalLogin = 203,
    UserIsNotActive = 204,
    InvalidTenancyName = 205,
    TenantIsNotActive = 206,
    LockedOut = 207,
    ConfirmEmailError = 208,
    AzureADAuthenticationDisabled = 209,
    TenantRegistrationDisabled = 210,
    UsernameConflict = 211,
    EmailConflict = 212,
}

export enum ErrorTranslationKeys {
    SessionExpired = 'generic_session_expired',
}
